import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/activitys/newPlayer/pop/bg.png'
import _imports_1 from '@/assets/images/activitys/newPlayer/cash_item_treasure.png'
import _imports_2 from '@/assets/images/activitys/newPlayer/pop/cash_tip_arrow.png'
import _imports_3 from '@/assets/images/common/btn_close.png'


const _hoisted_1 = { class: "mask" }
const _hoisted_2 = { class: "cash-back-prop" }
const _hoisted_3 = { class: "cash-back-content" }
const _hoisted_4 = { class: "i18n-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "items-content" }
const _hoisted_8 = { class: "cash-items" }
const _hoisted_9 = { class: "cash-item" }
const _hoisted_10 = { class: "item-content" }
const _hoisted_11 = { class: "item-top-tag" }
const _hoisted_12 = { class: "deposite-text display-column display-y-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "deposit-txt" }
const _hoisted_16 = { class: "return-div" }
const _hoisted_17 = { class: "return-text display-x-center display-y-center" }
const _hoisted_18 = { class: "return-num" }
const _hoisted_19 = { class: "return-amount" }

import { getChargeRebateInfo } from '@/api/v4';
import { currentChannel } from '@/config/config';
import { CHANNEL_CONFIG } from '@/config/constConfig';
import { changeAmount, changeMoney } from '@/utils/currencyUtils';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NewPlayerTips',
  setup(__props) {

let store = useStore();
    let router = useRouter();
    let { t } = useI18n();

    let configArr = ref<any[]>([]);

    onMounted(() => {
        initData();
    })

    function initData() {
        getChargeRebateInfo({}).then((res: any) => {
            if (res.data.success) {
                let result = res.data.data;
                configArr.value = result.web4ChargeRebateConfigs;
            }
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "bg",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "icon-2",
            src: require(`@/assets/images/activitys/newPlayer/pop/${_unref(t)('activitys.img.11')}`)
          }, null, 8, _hoisted_5),
          _createElementVNode("img", {
            class: "icon-3",
            src: require(`@/assets/images/activitys/newPlayer/pop/${_unref(t)('activitys.img.12')}`)
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configArr), (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)(`bouns.${16 + index}`)), 1),
                  _createElementVNode("div", _hoisted_12, [
                    (_unref(currentChannel).channel==_unref(CHANNEL_CONFIG).ID)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(currentChannel).currencyGold + _unref(changeMoney)(item.chargeAmount)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(currentChannel).currencyGold + _unref(changeAmount)(item.chargeAmount)), 1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('common.3')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)('bouns.3')), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(currentChannel).currencyGold + _unref(changeMoney)(item.returnAmount)), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", {
          class: "detail",
          onClick: _cache[0] || (_cache[0] = ()=> {
                    _unref(store).state.isShowCashBackProp = false;
                    _unref(router).push('/cashBack');
                })
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("div", null, _toDisplayString("Details"), -1),
          _createElementVNode("img", { src: _imports_2 }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "confirm",
          onClick: _cache[1] || (_cache[1] = ()=> {
                    _unref(store).state.isShowCashBackProp = false;
                    _unref(router).push('/deposit');
                })
        }, _toDisplayString("Depositar Agora"))
      ]),
      _createElementVNode("img", {
        class: "btn-close",
        src: _imports_3,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).state.isShowCashBackProp = false))
      })
    ])
  ]))
}
}

})